import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';

const MenuOption: React.FC<{
  title: string;
  icon: React.ReactElement;
  action: () => void;
  completed?: boolean;
}> = ({ title, icon, action, completed }) => {
  return (
    <TouchableOpacity
      className="w-full bg-light-100  drop-shadow-md rounded-lg flex flex-row justify-between items-center p-4 mb-3"
      onPress={action}
    >
      <Text className="text-sm ">{title}</Text>
      <View
        className={`flex h-10 w-10 rounded-full ${
          completed ? 'bg-secondary-800' : 'bg-secondary-200'
        }  justify-center items-center`}
      >
        {icon}
      </View>
    </TouchableOpacity>
  );
};

export default MenuOption;
